import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { api } from "../context/AuthContext";
import { Quote } from "lucide-react";

const initialsOf = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();

const TestimonialsSection = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/public/testimonials")
      .then(({ data }) => setItems(data || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      className="border-t border-[#0A1128]/10 bg-[#FCFAF8]"
      data-testid="testimonials-section"
      id="testimonials"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="md:max-w-2xl">
          <div className="overline mb-3">{t.testimonials.overline}</div>
          <h2 className="font-serif-display text-3xl md:text-5xl font-light leading-tight text-[#0A1128]">
            {t.testimonials.title}
          </h2>
          <p className="mt-5 text-[#3A435E] font-light leading-relaxed">
            {t.testimonials.subtitle}
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {items.map((it) => (
            <article
              key={it.id}
              className="bg-[#F4F1EB]/50 border border-[#0A1128]/10 p-7 flex flex-col"
              data-testid={`testimonial-card-${it.id}`}
            >
              <Quote size={22} strokeWidth={1.3} className="text-[#C5A059]" />
              <blockquote className="mt-4 font-serif-display text-lg md:text-xl text-[#0A1128] leading-snug font-light flex-1">
                «{it.quote}»
              </blockquote>
              <div className="mt-6 pt-5 border-t border-[#0A1128]/10 flex items-center gap-3">
                {it.avatar_url ? (
                  <img
                    src={it.avatar_url}
                    alt={it.name}
                    className="w-11 h-11 object-cover grayscale-[0.1]"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-11 h-11 bg-[#0A1128] text-[#F4F1EB] grid place-items-center text-xs tracking-[0.18em]">
                    {initialsOf(it.name)}
                  </div>
                )}
                <div className="leading-tight">
                  <div className="text-[#0A1128] font-medium text-sm">{it.name}</div>
                  <div className="text-[10px] tracking-[0.18em] uppercase text-[#3A435E] mt-1">
                    {it.role || it.location}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
